import {
  Card, Divider, Form, Radio,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { SignInForm } from './sign-in';
import { SignUpForm } from './sign-up';
import PasswordResetForm from './password-reset';
import { inMemoryAuth } from './in-memory-auth';
import { CreateAccountCard } from '../cards/action-card/create-account-card';

export const AuthForm = () => {
  const [mode, setMode] = useState('sign-in');
  const [form] = Form.useForm();
  const { pathname } = useLocation();

  useEffect(() => {
    if (inMemoryAuth.token) {
      navigate('/user/account');
    }
  }, []);

  let authForm;
  switch (mode) {
    case 'sign-in':
      authForm = (
        <SignInForm
          form={form}
          setMode={setMode}
        />
      );
      break;
    case 'sign-up':
      authForm = (
        <SignUpForm
          form={form}
        />
      );
      break;
    default:
      authForm = <PasswordResetForm />;
      break;
  }

  return (
    <>
      {pathname === '/user/auth/' && (
        <>
          <CreateAccountCard />
          <Divider />
        </>
      )}
      <Card
        extra={[
          <Radio.Group size="large" value={mode} onChange={(e) => setMode(e.target.value)}>
            <Radio.Button value="sign-in">
              Sign In
            </Radio.Button>
            <Radio.Button value="sign-up">
              Sign Up
            </Radio.Button>
          </Radio.Group>]}
      >
        {authForm}
      </Card>
    </>
  );
};
